import React from "react";

export default function NewsBanner() {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-blue-700 via-blue-600 to-indigo-700 p-6 md:p-8 text-white shadow-md">
      {/* Decorative background shapes */}
      <div className="absolute -right-10 -bottom-10 w-64 h-64 rounded-full bg-white opacity-10 pointer-events-none" />
      <div className="absolute right-40 -top-20 w-48 h-48 rounded-full bg-white opacity-5 pointer-events-none" />

      <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="max-w-2xl">
          <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight uppercase mb-2 drop-shadow-sm">
            BẢNG TIN KẾ TOÁN
          </h1>
          <p className="text-blue-100 text-sm md:text-base font-normal">
            Cập nhật thông báo, hướng dẫn và tin tức vận hành cho hệ thống.
          </p>
        </div>

        {/* Right side illustration graphic mockup */}
        <div className="hidden lg:flex items-center space-x-3 bg-white/10 backdrop-blur-sm p-3 px-5 rounded-xl border border-white/20 shadow-inner">
          <div className="relative w-16 h-12 bg-white/20 rounded-lg border border-white/30 flex items-center justify-center shadow-sm">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-400 rounded-full border-2 border-blue-600 flex items-center justify-center">
              <span className="text-[10px] text-blue-900 font-bold">✓</span>
            </div>
          </div>
          
          <div className="flex flex-col">
            <span className="text-xs font-semibold text-blue-100 uppercase tracking-wider">Hệ thống ICOOL</span>
            <span className="text-sm font-bold text-white">Quản Lý Kế Toán</span>
          </div>
        </div>
      </div>
    </div>
  );
}
